export const kInvalidUserFilesNameMessage = 'Invalid characters in name'

// Check if the name contains slashes or control characters
export function hasInvalidUserFilesNameCharacter(value: string) {
  return /[/\\]|\p{Cc}/u.test(value)
}
